module.exports = __webpack_public_path__ + "static/media/destinations.5129ac8c.webp";